// extracted by mini-css-extract-plugin
module.exports = {"pointer":"dialog_pointer__zOdkM","dialog":"dialog_dialog__zJcIT"};